export const eventNames = {
  project: {
    loaded: 'crux.project.loaded',
  },
  asset: {
    loaded: 'crux.asset.loaded',
    loadedchildren: 'crux.asset.loadedchildren',
    created: 'crux.asset.created',
    updated: 'crux.asset.updated',
    uploaded: 'crux.asset.uploaded',
  },
  comment: {
    loaded: 'crux.comment.loaded',
    created: 'crux.comment.created',
    updated: 'crux.comment.updated',
    deleted: 'crux.comment.deleted',
  },
  object: {
    selected: 'crux.object.selected',
  },
  user: {
    followed: 'crux.user.followed',
  },
  resource: {
    selected: 'crux.resource.selected',
    created: 'crux.resource.created',
    updated: 'crux.resource.updated',
    deleted: 'crux.resource.deleted',
  },
};

export const MIXPANEL_ALLOWED_KEYS = [
  'code',
  'crux_version',
  'crux_template',
  'asset_type',
  'folder',
  'name',
  'type',
  'user',
  'asset',
  'space',
];
